import * as Highcharts from 'highcharts';
import { Component } from 'react';

const initChart = () => {
    const strCategoriesValue = $('#hfdChartCategories').val();
    if (!strCategoriesValue) return;

    Highcharts.setOptions({
        lang: {
            thousandsSep: '.'
        }
    });

    const strCategories = strCategoriesValue.toString();
    const chartCategories = strCategories.split(',');


    //const strSeries = JSON.stringify($('#hfdChartSeries').val().toString());
    //const chartSeries = JSON.parse(strSeries);
    var dataStr = $('#hfdChartSeries').val().toString();
    const strSeries = dataStr.replace(/\\n/g, "\\n")
                             .replace(/\\'/g, "\\'")
                             .replace(/\\"/g, '\\"')
                             .replace(/\\&/g, "\\&")
                             .replace(/\\r/g, "\\r")
                             .replace(/\\t/g, "\\t")
                             .replace(/\\b/g, "\\b")
                             .replace(/\\f/g, "\\f");

    const chartSeries = JSON.parse(strSeries);

    Highcharts.chart('chart', {
        tooltip: {
            useHTML: true,
            style: {
                direction: 'rtl',
                fontFamily: 'IranSans'
            }
        },
        chart: {
            type: 'line'
        },
        title: {
            text: ''
        },
        xAxis: {
            categories: chartCategories
        },
        yAxis: {
            title: {
                text: 'دامنه تغییرات قیمت (تومان)'
            },
            labels: {
                formatter() {
                    return Highcharts.numberFormat(this.value, 0);
                }
            }
        },
        series: chartSeries,
        credits: {
            enabled: false
        }
    });
};

export {
    initChart
};
